import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import { GET_TOKEN } from '../gql/auth';
import AccessDenied from './layout/AccessDenied';

const PrivateRoute = ({ component: Component, adminOnly, ...rest }) => {
  const {
    data: { isLoggedIn, role },
    loading,
  } = useQuery(GET_TOKEN);
  const location = useLocation();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isLoggedIn && !loading) {
          return (
            <Redirect
              to={{
                pathname: '/redirectSSO',
                state: { prevPath: location.pathname },
              }}
            />
          );
        }
        if (adminOnly && role !== 'Admin') {
          return <AccessDenied />;
        }
        return <Component {...props} />;
      }}
    />
  );
};

PrivateRoute.defaultProps = {
  adminOnly: false,
};

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  adminOnly: PropTypes.bool,
};

export default PrivateRoute;
